export const PART_PALETTE = {
  disc: 0xc65f5f,
  brain: 0xf2c4d4,
  prostate: 0xd88a76,
  bladder: 0xe2bfc2,
  cord: 0xf2a5c0,
  vertebra: 0xe9d8a6,
  sacrum: 0xe9d8a6,
  hip: 0xe9d8a6,
  femur: 0xe9d8a6,
  colon: 0x844600,
};

export const DEFAULT_PART_COLOR = 0x8a1d16;

export function getPartColor(filename = "") {
  const key = Object.keys(PART_PALETTE).find((part) =>
    filename.toLowerCase().includes(part)
  );
  return key ? PART_PALETTE[key] : DEFAULT_PART_COLOR;
}

export function colorToCssHex(colorInt) {
  return `#${colorInt.toString(16).padStart(6, "0")}`;
}
